import { CardStatus, CreateCardRequest, Customization, ListCardsRequest, Relationship, TerminateCardRequest } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { StartChallengeRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/common/challenge/start_challenge';
import { WebURL } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import { DeactivateCheckingRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/checking/checking_service';
import { ProvideFeedbackRequest } from '@square/dashboard-protos/models/squareup/bizbank/service';
import { ActionType as BBRiskActionType } from '@square/dashboard-protos/models/squareup/bbrisk/action';
import TextRenderer from '@banking/ui/utils/text-renderer';
import { ACCOUNT_CLOSURE_FLOW_ACCOUNT_HOLDER_CARD, ACCOUNT_CLOSURE_FLOW_WITHOUT_CANCELLATION_REASON_SELECTION, CANCELLATION_FLOW_ACCOUNT_HOLDER_CARD, CancellationType, DEACTIVATE_OWN_CARDS_FLOW_ACCOUNT_HOLDER_CARD, DEACTIVATE_OWN_CARDS_FLOW_WITHOUT_CANCELLATION_REASON_SELECTION, DEACTIVATION_FLOW_ACCOUNT_HOLDER_CARD, DOCUMENT_BASED_IDV_FLOW, REORDER_SCREENS_AFTER_ADDRESS_AND_CUSTOMIZATION, Screen, TWO_FACTOR_FLOW, userClickNextAction } from '@banking/ui/workflows/card-settings/cancel-card/index';
import * as addressValidationWorkflow from '@banking/ui/workflows/common/address-validation';
import * as cardCustomizationWorkflow from '@banking/ui/workflows/common/card-customization';
import * as twoFactorWorkflow from '@banking/ui/workflows/common/two-factor';
import assert from '@banking/ui/utils/assert';
import { validatePhoneNumber } from '@banking/ui/utils/document-based-idv';
import { getNavigationWithInjectedScreen, incrementNavigation } from '@banking/ui/workflows/common/utils';
export let AccountHolderCardScreen = /*#__PURE__*/function (AccountHolderCardScreen) {
  AccountHolderCardScreen["CancellationReasonSelection"] = "ACCOUNT_HOLDER_CARD_SCREEN_CANCELLATION_REASON_SELECTION";
  AccountHolderCardScreen["ReplacementCustomizationSelection"] = "ACCOUNT_HOLDER_CARD_SCREEN_REPLACEMENT_CUSTOMIZATION_SELECTION";
  AccountHolderCardScreen["Customization"] = "ACCOUNT_HOLDER_CARD_SCREEN_CUSTOMIZATION";
  AccountHolderCardScreen["ConfirmShippingAddress"] = "ACCOUNT_HOLDER_CARD_SCREEN_CONFIRM_SHIPPING_ADDRESS";
  AccountHolderCardScreen["EditShippingAddress"] = "ACCOUNT_HOLDER_CARD_SCREEN_EDIT_SHIPPING_ADDRESS";
  AccountHolderCardScreen["NormalizeAddress"] = "ACCOUNT_HOLDER_CARD_SCREEN_NORMALIZE_ADDRESS";
  AccountHolderCardScreen["UnrecognizedAddress"] = "ACCOUNT_HOLDER_CARD_SCREEN_UNRECOGNIZED_ADDRESS";
  AccountHolderCardScreen["ConfirmReplacement"] = "ACCOUNT_HOLDER_CARD_SCREEN_CONFIRM_REPLACEMENT";
  AccountHolderCardScreen["OtherProblemWithCard"] = "ACCOUNT_HOLDER_CARD_SCREEN_OTHER_PROBLEM";
  AccountHolderCardScreen["SendFeedback"] = "ACCOUNT_HOLDER_CARD_SCREEN_SEND_FEEDBACK";
  AccountHolderCardScreen["ConfirmDeactivation"] = "ACCOUNT_HOLDER_CARD_SCREEN_CONFIRM_DEACTIVATION";
  AccountHolderCardScreen["AccountClosureOrCardDeactivationSelection"] = "ACCOUNT_HOLDER_CARD_SCREEN_ACCOUNT_CLOSURE_OR_CARD_DEACTIVATION_SELECTION";
  AccountHolderCardScreen["ConfirmAccountClosure"] = "ACCOUNT_HOLDER_CARD_SCREEN_CONFIRM_ACCOUNT_CLOSURE";
  AccountHolderCardScreen["AccountClosed"] = "ACCOUNT_HOLDER_CARD_SCREEN_ACCOUNT_CLOSED";
  AccountHolderCardScreen["ShippingAddressUnverified"] = "ACCOUNT_HOLDER_CARD_SCREEN_SHIPPING_ADDRESS_UNVERIFIED";
  AccountHolderCardScreen["ShippingAddressStandardized"] = "ACCOUNT_HOLDER_CARD_SCREEN_SHIPPING_ADDRESS_STANDARDIZED";
  AccountHolderCardScreen["ConfirmOwnCardsDeactivation"] = "ACCOUNT_HOLDER_CARD_SCREEN_CONFIRM_OWN_CARDS_DEACTIVATION";
  AccountHolderCardScreen["OwnCardsDeactivationSuccess"] = "ACCOUNT_HOLDER_CARD_SCREEN_OWN_CARDS_DEACTIVATION_SUCCESS";
  AccountHolderCardScreen["CardReorderSuccess"] = "ACCOUNT_HOLDER_CARD_SCREEN_CARD_REORDER_SUCCESS";
  AccountHolderCardScreen["DocumentBasedIdvConsent"] = "ACCOUNT_HOLDER_CARD_SCREEN_DOCUMENT_BASED_IDV_CONSENT";
  AccountHolderCardScreen["DocumentBasedIdvPhoneNumberInput"] = "ACCOUNT_HOLDER_CARD_SCREEN_PHONE_NUMBER_INPUT";
  AccountHolderCardScreen["DocumentBasedIdvInstructions"] = "ACCOUNT_HOLDER_CARD_SCREEN_INSTRUCTIONS";
  AccountHolderCardScreen["DocumentBasedIdvResendLink"] = "ACCOUNT_HOLDER_CARD_SCREEN_RESEND_LINK";
  AccountHolderCardScreen["TwoFactorPhoneNumber"] = "ACCOUNT_HOLDER_CARD_SCREEN_TWO_FACTOR_PHONE_NUMBER";
  AccountHolderCardScreen["TwoFactorVerifyCode"] = "ACCOUNT_HOLDER_CARD_SCREEN_TWO_FACTOR_VERIFY_CODE";
  return AccountHolderCardScreen;
}({});
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["CountryAddressDataReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/COUNTRY_ADDRESS_DATA_RECEIVED";
  ActionType["CountryAddressDataRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/COUNTRY_ADDRESS_DATA_REJECTED";
  ActionType["CreateCardCustomizationReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/CREATE_CARD_CUSTOMIZATION_RECEIVED";
  ActionType["CreateCardCustomizationRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/CREATE_CARD_CUSTOMIZATION_REJECTED";
  ActionType["CreateCard"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/CREATE_CARD";
  ActionType["CreateCardReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/CREATE_CARD_RECEIVED";
  ActionType["CreateCardRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/CREATE_CARD_REJECTED";
  ActionType["DeactivateAccountReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/DEACTIVATE_ACCOUNT_RECEIVED";
  ActionType["DeactivateAccountRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/DEACTIVATE_ACCOUNT_REJECTED";
  ActionType["ListCardsReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/LIST_CARDS_RECEIVED";
  ActionType["ListCardsRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/LIST_CARDS_REJECTED";
  ActionType["MultipassStatusReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/MULTIPASS_STATUS_RECEIVED";
  ActionType["MultipassStatusRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/MULTIPASS_STATUS_REJECTED";
  ActionType["PhoneNumberChange"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/PHONE_NUMBER_CHANGE";
  ActionType["ProvideFeedbackReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/PROVIDE_FEEDBACK_RECEIVED";
  ActionType["ProvideFeedbackRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/PROVIDE_FEEDBACK_REJECTED";
  ActionType["ShippingAddressChange"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/SHIPPING_ADDRESS_CHANGE";
  ActionType["StartChallengeReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/START_CHALLENGE_RECEIVED";
  ActionType["StartChallengeRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/START_CHALLENGE_REJECTED";
  ActionType["UserChooseDeactivateOwnCardsFlow"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CHOOSE_DEACTIVATE_OWN_CARDS_FLOW";
  ActionType["UserChooseAccountClosureFlow"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CHOOSE_ACCOUNT_CLOSURE_FLOW";
  ActionType["UserClickDeactivateAccount"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_DEACTIVATE_ACCOUNT";
  ActionType["UserClickDeactivateOwnCards"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_DEACTIVATE_OWN_CARDS";
  ActionType["UserClickCancellationReason"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_CANCELLATION_REASON";
  ActionType["UserClickConfirmCardCustomization"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_CONFIRM_CARD_CUSTOMIZATION";
  ActionType["UserClickDesignNewCard"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_DESIGN_NEW_CARD";
  ActionType["UserClickEditShippingAddress"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_EDIT_SHIPPING_ADDRESS";
  ActionType["UserClickOrderReplacementUsingSameDesign"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_ORDER_REPLACEMENT_USING_SAME_DESIGN";
  ActionType["UserClickSendFeedback"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_SEND_FEEDBACK";
  ActionType["UserClickSendIdvVerificationLink"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_SEND_IDV_VERIFICATION_LINK";
  ActionType["UserClickStartChallenge"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/USER_CLICK_START_CHALLENGE";
  ActionType["DeactivateOwnCardsReceived"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/DEACTIVATE_OWN_CARDS_RECEIVED";
  ActionType["DeactivateOwnCardsRejected"] = "CARD_MANAGEMENT/CANCEL_CARD/ACCOUNT_HOLDER_CARD/DEACTIVATE_OWN_CARDS_REJECTED";
  return ActionType;
}({});
export const countryAddressDataReceivedAction = response => ({
  type: ActionType.CountryAddressDataReceived,
  response
});
export const countryAddressDataRejectedAction = error => ({
  type: ActionType.CountryAddressDataRejected,
  error
});
export const createCardCustomizationReceivedAction = response => ({
  type: ActionType.CreateCardCustomizationReceived,
  response
});
export const createCardCustomizationRejectedAction = error => ({
  type: ActionType.CreateCardCustomizationRejected,
  error
});
export const createCardAction = () => ({
  type: ActionType.CreateCard
});
export const createCardReceivedAction = response => ({
  type: ActionType.CreateCardReceived,
  response
});
export const createCardRejectedAction = error => ({
  type: ActionType.CreateCardRejected,
  error
});
export const deactivateAccountReceivedAction = () => ({
  type: ActionType.DeactivateAccountReceived
});
export const deactivateAccountRejectedAction = error => ({
  type: ActionType.DeactivateAccountRejected,
  error
});
export const deactivateOwnCardsReceivedAction = responses => ({
  type: ActionType.DeactivateOwnCardsReceived,
  responses
});
export const deactivateOwnCardsRejectedAction = error => ({
  type: ActionType.DeactivateOwnCardsRejected,
  error
});
export const listCardsReceivedAction = response => ({
  type: ActionType.ListCardsReceived,
  response
});
export const listCardsRejectedAction = error => ({
  type: ActionType.ListCardsRejected,
  error
});
export const multipassStatusReceivedAction = response => ({
  type: ActionType.MultipassStatusReceived,
  response
});
export const multipassStatusRejectedAction = error => ({
  type: ActionType.MultipassStatusRejected,
  error
});
export const phoneNumberChangeAction = phoneNumber => ({
  type: ActionType.PhoneNumberChange,
  phoneNumber
});
export const provideFeedbackReceivedAction = response => ({
  type: ActionType.ProvideFeedbackReceived,
  response
});
export const provideFeedbackRejectedAction = error => ({
  type: ActionType.ProvideFeedbackRejected,
  error
});
export const startChallengeReceivedAction = response => ({
  type: ActionType.StartChallengeReceived,
  response
});
export const startChallengeRejectedAction = error => ({
  type: ActionType.StartChallengeRejected,
  error
});
export const shippingAddressChangeAction = address => ({
  type: ActionType.ShippingAddressChange,
  address
});
export const userChooseDeactivateOwnCardsFlowAction = () => ({
  type: ActionType.UserChooseDeactivateOwnCardsFlow
});
export const userChooseAccountClosureFlowAction = () => ({
  type: ActionType.UserChooseAccountClosureFlow
});
export const userClickCancellationReasonAction = reason => ({
  type: ActionType.UserClickCancellationReason,
  reason
});
export const userClickDeactivateAccountAction = () => ({
  type: ActionType.UserClickDeactivateAccount
});
export const userClickConfirmCardCustomizationAction = () => ({
  type: ActionType.UserClickConfirmCardCustomization
});
export const userClickDeactivateOwnCardsAction = () => ({
  type: ActionType.UserClickDeactivateOwnCards
});
export const userClickDesignNewCardAction = () => ({
  type: ActionType.UserClickDesignNewCard
});
export const userClickEditShippingAddressAction = () => ({
  type: ActionType.UserClickEditShippingAddress
});
export const userClickOrderReplacementUsingSameDesignAction = () => ({
  type: ActionType.UserClickOrderReplacementUsingSameDesign
});
export const userClickSendFeedbackAction = feedbackText => ({
  type: ActionType.UserClickSendFeedback,
  feedbackText
});
export const userClickSendIdvVerificationLinkAction = () => ({
  type: ActionType.UserClickSendIdvVerificationLink
});
export const userClickStartChallengeAction = () => ({
  type: ActionType.UserClickStartChallenge
});
function handleCountryAddressDataReceived(state, action) {
  const {
    response
  } = action;
  return [{
    ...state,
    countryAddressData: response,
    loading: false,
    navigation: getNavigationWithInjectedScreen(state.navigation, AccountHolderCardScreen.EditShippingAddress)
  }, null];
}
function handleCountryAddressDataRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Country address data - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleCreateCardCustomizationReceived(context, state, action) {
  const {
    response
  } = action;
  if (!response.success) {
    context.sentry.captureException('Cancel card - CreateCardCustomization error');
    return [{
      ...state,
      loading: false,
      navigation: {
        flow: [Screen.Error],
        current: Screen.Error
      }
    }, null];
  }
  return [{
    ...state,
    reorderedCardCustomizationId: response.cutomizationToken,
    loading: false,
    navigation: incrementNavigation(state.navigation)
  }, null];
}
function handleCreateCardCustomizationRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Create card customization - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleCreateCard(context, state) {
  const {
    chosenAddress,
    normalizedAddress
  } = state.addressValidation;
  const work = () => context.createCard(CreateCardRequest.create({
    cardCustomization: Customization.create({
      // If the customer doesn’t customize their card when reordering, we will reuse the customization data from the terminated card.
      id: state.reorderedCardCustomizationId ?? state.cardCustomizationId,
      cardTexts: [Customization.CardText.create({
        type: Customization.CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME,
        text: state.businessName
      }), Customization.CardText.create({
        type: Customization.CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME,
        text: state.cardHolder
      })]
    }),
    idempotenceKey: context.uuid(),
    shippingAddress: chosenAddress === addressValidationWorkflow.ChosenAddress.Normalized ? normalizedAddress : state.updatedShippingAddress,
    unitToken: state.unitToken
  })).then(createCardReceivedAction, createCardRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleIncrementNavigationFromTwoFactorScreen(context, state, action) {
  const [twoFactor] = twoFactorWorkflow.update({
    getUUIDString: context.uuid,
    translate: key => context.intl.t(key),
    multipass: context.multipass
  })(state.twoFactor, action);
  let navigation = state.navigation;
  if (twoFactor.enrollmentComplete) {
    // Remove all 2FA screens from the current flow, so that when user goes back in the flow they don't see those again
    const updatedFlow = navigation.flow.filter(screen => !TWO_FACTOR_FLOW.includes(screen));
    const currentScreenIndex = state.navigation.flow.indexOf(state.navigation.current);
    // Find the next screen in the flow after 2FA flow is removed
    let nextScreenIndex = currentScreenIndex - TWO_FACTOR_FLOW.length + 1;
    if (nextScreenIndex < 0) {
      nextScreenIndex = 0;
    }
    navigation = {
      ...navigation,
      flow: updatedFlow,
      current: updatedFlow[nextScreenIndex]
    };
  } else {
    navigation = incrementNavigation(state.navigation);
  }
  return [{
    ...state,
    twoFactor,
    navigation
  }, null];
}
function handleUpdateNavigationAfterAddressVerification(context, state, action) {
  const [addressValidation] = addressValidationWorkflow.update({
    sentry: context.sentry,
    validateAddress: context.validateAddress
  })(state.addressValidation, action);
  switch (addressValidation.result) {
    case addressValidationWorkflow.AddressValidationResult.NORMALIZED:
      return [{
        ...state,
        navigation: getNavigationWithInjectedScreen(state.navigation, AccountHolderCardScreen.ShippingAddressStandardized, REORDER_SCREENS_AFTER_ADDRESS_AND_CUSTOMIZATION)
      }, null];
    case addressValidationWorkflow.AddressValidationResult.UNVERIFIED:
      return [{
        ...state,
        navigation: getNavigationWithInjectedScreen(state.navigation, AccountHolderCardScreen.ShippingAddressUnverified, REORDER_SCREENS_AFTER_ADDRESS_AND_CUSTOMIZATION)
      }, null];
    default:
      return [{
        ...state,
        navigation: incrementNavigation(state.navigation)
      }, null];
  }
}
function handleCreateCardReceived(context, state, action) {
  const {
    response
  } = action;
  if (response.errors.length > 0) {
    context.sentry.captureException(`Cancel card - CreateCard errors: ${response.errors}`);
    return [{
      ...state,
      loading: false,
      navigation: {
        flow: [Screen.Error],
        current: Screen.Error
      }
    }, null];
  }
  if (response.challenge) {
    // If on DocumentBasedIdvInstructions, that means user tried to reorder after requesting an idv challenge
    if (state.navigation.current === AccountHolderCardScreen.DocumentBasedIdvInstructions) {
      return [{
        ...state,
        loading: false,
        navigation: incrementNavigation(state.navigation)
      }, null];
    }
    const currentScreenIndex = state.navigation.flow.indexOf(state.navigation.current);
    const newFlow = [...state.navigation.flow.slice(0, currentScreenIndex + 1), ...DOCUMENT_BASED_IDV_FLOW];
    return [{
      ...state,
      loading: false,
      navigation: {
        flow: newFlow,
        current: AccountHolderCardScreen.DocumentBasedIdvConsent
      }
    }, null];
  }
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [AccountHolderCardScreen.CardReorderSuccess],
      current: AccountHolderCardScreen.CardReorderSuccess
    }
  }, null];
}
function handleCreateCardRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Create card - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleDeactivateAccountReceived(state) {
  return [{
    ...state,
    accountClosed: true,
    loading: false,
    navigation: incrementNavigation(state.navigation)
  }, null];
}
function handleDeactivateAccountRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Deactivate account - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleDeactivateOwnCardsReceived(context, state, action) {
  const {
    responses
  } = action;
  for (const response of responses) {
    if (response.errors.length > 0) {
      context.sentry.captureException(`Cancel card - Deactivate own card errors: ${response.errors}`);
      return [{
        ...state,
        loading: false,
        navigation: {
          flow: [Screen.Error],
          current: Screen.Error
        }
      }, null];
    }
  }
  return [{
    ...state,
    loading: false,
    navigation: incrementNavigation(state.navigation)
  }, null];
}
function handleDeactivateOwnCardsRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Deactivate own card - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleListCardsReceived(state, action) {
  const {
    response
  } = action;
  const nonTerminatedCards = response.cards.filter(c => c.status !== CardStatus.CARD_STATUS_TERMINATED);
  const accountOwnerCards = nonTerminatedCards.filter(c => c.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER));
  let navigation = {
    flow: state.navigation.flow,
    current: AccountHolderCardScreen.AccountClosureOrCardDeactivationSelection
  };
  // If there are no active cards, skip the screen that displays activated cards as a warning
  if (nonTerminatedCards.length === 0) {
    const updatedAccountClosureFlow = navigation.flow.filter(screen => screen !== AccountHolderCardScreen.AccountClosureOrCardDeactivationSelection);
    navigation = {
      flow: updatedAccountClosureFlow,
      current: AccountHolderCardScreen.ConfirmAccountClosure
    };
  }
  return [{
    ...state,
    accountOwnerCards,
    cards: nonTerminatedCards,
    loading: false,
    navigation
  }, null];
}
function handleListCardsRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`ListCards - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleMultipassStatusReceived(state, action) {
  const {
    response
  } = action;
  let navigation = state.navigation;
  const has2FAEnrollment = response.requiresTwoFactor;
  // Append 2FA screens if user doesn't have 2FA enrollment and the current flow doesn't already have these screens
  if (!has2FAEnrollment && !state.navigation.flow.includes(TWO_FACTOR_FLOW[0])) {
    const currentScreenIndex = state.navigation.flow.indexOf(state.navigation.current);
    const newFlow = [...state.navigation.flow.slice(0, currentScreenIndex + 1), ...TWO_FACTOR_FLOW, ...state.navigation.flow.slice(currentScreenIndex + 1)];
    navigation = {
      ...navigation,
      flow: newFlow
    };
  }
  return [{
    ...state,
    twoFactor: {
      ...state.twoFactor,
      enrollmentComplete: has2FAEnrollment
    },
    loading: false,
    navigation: incrementNavigation(navigation)
  }, null];
}
function handleMultipassStatusRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`MultipassStatus - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handlePhoneNumberChange(state, action) {
  const {
    phoneNumber
  } = action;
  return [{
    ...state,
    phoneNumber,
    phoneNumberError: ''
  }, null];
}
function handleProvideFeedbackReceived(context, state, action) {
  const {
    response
  } = action;
  if (!response.success) {
    context.sentry.captureException('Cancel card - ProvideFeedback error');
    return [{
      ...state,
      loading: false,
      navigation: {
        flow: [Screen.Error],
        current: Screen.Error
      }
    }, null];
  }
  return [{
    ...state,
    loading: false,
    navigation: incrementNavigation(state.navigation)
  }, null];
}
function handleProvideFeedbackRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Provide feedback - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleStartChallengeReceived(context, state) {
  const resendChallengeLinkScreens = [AccountHolderCardScreen.DocumentBasedIdvInstructions, AccountHolderCardScreen.DocumentBasedIdvResendLink];
  // Don't show the toast message if user is requesting the link for the first time
  if (resendChallengeLinkScreens.includes(state.navigation.current)) {
    context.marketToasts.success(context.intl.t('banking.checking.documentBasedIdv.toast.text'));
  }
  return [{
    ...state,
    loading: false,
    navigation: {
      ...state.navigation,
      current: AccountHolderCardScreen.DocumentBasedIdvInstructions
    }
  }, null];
}
function handleStartChallengeRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Start challenge - ${error}`);
  return [{
    ...state,
    loading: false,
    navigation: {
      flow: [Screen.Error],
      current: Screen.Error
    }
  }, null];
}
function handleUserClickCancellationReason(context, state, action) {
  const {
    reason
  } = action;
  switch (reason) {
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_LOST_OR_STOLEN:
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_DAMAGED:
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_CARD_NOT_RECEIVED:
      return [{
        ...state,
        loading: true,
        modalOpen: true,
        reason,
        replace: true,
        navigation: {
          ...state.navigation,
          flow: CANCELLATION_FLOW_ACCOUNT_HOLDER_CARD
        }
      }, () => context.fetchMultipassStatus().then(multipassStatusReceivedAction, multipassStatusRejectedAction)];
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_CANCEL:
      return [{
        ...state,
        reason,
        navigation: {
          flow: DEACTIVATION_FLOW_ACCOUNT_HOLDER_CARD,
          current: AccountHolderCardScreen.ConfirmDeactivation
        }
      }, null];
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_ACCOUNT_CLOSED:
      return [{
        ...state,
        navigation: {
          flow: ACCOUNT_CLOSURE_FLOW_ACCOUNT_HOLDER_CARD,
          current: AccountHolderCardScreen.CancellationReasonSelection
        },
        loading: true,
        reason
      }, () => context.listCards(ListCardsRequest.create({
        balanceId: state.balanceId
      })).then(listCardsReceivedAction, listCardsRejectedAction)];
    case TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_OTHER:
      return [{
        ...state,
        reason,
        navigation: {
          flow: [AccountHolderCardScreen.CancellationReasonSelection, AccountHolderCardScreen.OtherProblemWithCard],
          current: AccountHolderCardScreen.OtherProblemWithCard
        }
      }, null];
    default:
      context.sentry.captureException(`handleUserClickCancellationReason does not support reason: ${reason}`);
      return [{
        ...state,
        navigation: {
          flow: [Screen.Error],
          current: Screen.Error
        }
      }, null];
  }
}
function handleUserClickConfirmCardCustomization(context, state) {
  const idempotenceKey = context.uuid();
  const work = () => cardCustomizationWorkflow.renderCardCustomization(TextRenderer)({
    newCustomizationActive: state.newCustomizationActive,
    signatureFont: state.signatureFont,
    signatureText: state.signatureText
  }).then(cardCustomizationWorkflow.createCardCustomizationRequest(idempotenceKey, state.unitToken)).then(request => context.createCardCustomization(request)).then(createCardCustomizationReceivedAction, createCardCustomizationRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleUserChooseAccountClosureFlow(state) {
  const flow = state.cancellationType === CancellationType.AccountHolderAccount ? ACCOUNT_CLOSURE_FLOW_WITHOUT_CANCELLATION_REASON_SELECTION : ACCOUNT_CLOSURE_FLOW_ACCOUNT_HOLDER_CARD;
  return [{
    ...state,
    navigation: {
      current: AccountHolderCardScreen.ConfirmAccountClosure,
      flow
    }
  }, null];
}
function handleUserChooseDeactivateOwnCardsFlow(state) {
  const flow = state.cancellationType === CancellationType.AccountHolderAccount ? DEACTIVATE_OWN_CARDS_FLOW_WITHOUT_CANCELLATION_REASON_SELECTION : DEACTIVATE_OWN_CARDS_FLOW_ACCOUNT_HOLDER_CARD;
  return [{
    ...state,
    navigation: {
      current: AccountHolderCardScreen.ConfirmOwnCardsDeactivation,
      flow
    }
  }, null];
}
function handleUserClickDeactivateAccount(context, state) {
  const work = () => context.deactivateAccount(DeactivateCheckingRequest.create({
    unitToken: state.unitToken
  })).then(deactivateAccountReceivedAction, deactivateAccountRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleUserClickDeactivateOwnCards(context, state) {
  const {
    accountOwnerCards
  } = state;
  assert(accountOwnerCards.length > 0);
  const work = () => {
    const promises = accountOwnerCards.map(card => context.terminateCard(TerminateCardRequest.create({
      cardToken: card.id,
      reason: TerminateCardRequest.TerminateCardReason.TERMINATE_CARD_REASON_CANCEL
    })));
    return Promise.all(promises).then(deactivateOwnCardsReceivedAction).catch(deactivateOwnCardsRejectedAction);
  };
  return [{
    ...state,
    loading: true
  }, work];
}
function handleUserClickDesignNewCard(state) {
  const navigation = getNavigationWithInjectedScreen(state.navigation, AccountHolderCardScreen.Customization);
  return [{
    ...state,
    navigation
  }, null];
}
function handleUserClickOrderReplacementUsingSameDesign(context, state) {
  // when ordering replacement using the same design
  // create a new customization token if business info has been updated
  // otherwise, reuse the same customization id/token

  if (state.hasUpdatedBusinessInfo) {
    const idempotenceKey = context.uuid();
    const request = cardCustomizationWorkflow.createCardCustomizationRequest(idempotenceKey, state.unitToken)(state.cardCustomization?.imageBytes);
    const work = () => context.createCardCustomization(request).then(createCardCustomizationReceivedAction, createCardCustomizationRejectedAction);
    return [{
      ...state,
      loading: true
    }, work];
  } else {
    return [{
      ...state,
      reorderedCardCustomizationId: null
    }, userClickNextAction];
  }
}
function handleUserClickEditShippingAddress(context, state) {
  const work = () => context.lookupCountryAddressData().then(countryAddressDataReceivedAction, countryAddressDataRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleUserClickSendFeedback(context, state, action) {
  const {
    feedbackText
  } = action;
  const {
    unitToken
  } = state;
  const idempotenceKey = context.uuid();
  const work = () => context.provideFeedback(ProvideFeedbackRequest.create({
    feedbackText,
    feedbackSource: ProvideFeedbackRequest.FeedbackSource.CARD_DEACTIVATION,
    idempotenceKey,
    unitToken
  })).then(provideFeedbackReceivedAction, provideFeedbackRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleUserClickSendVerificationLink(context, state) {
  if (!validatePhoneNumber(state.phoneNumber, context.userInfo.countryCode)) {
    return [{
      ...state,
      phoneNumberError: context.intl.t('banking.checking.onboarding.twoFactor.phoneNumber.validation.invalidNumber')
    }, null];
  }
  return [state, userClickStartChallengeAction];
}
function handleUserClickStartChallenge(context, state) {
  const work = () => context.startChallenge(StartChallengeRequest.create({
    unitToken: state.unitToken,
    phoneNumber: state.phoneNumber,
    actionType: BBRiskActionType.CARD_ORDER,
    countryCode: context.userInfo.countryCode,
    webUrl: WebURL.create({
      urlString: window.location.href
    })
  })).then(startChallengeReceivedAction, startChallengeRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
export const update = context =>
// eslint-disable-next-line complexity
(state, action) => {
  switch (action.type) {
    case ActionType.CountryAddressDataReceived:
      return handleCountryAddressDataReceived(state, action);
    case ActionType.CountryAddressDataRejected:
      return handleCountryAddressDataRejected(context, state, action);
    case ActionType.CreateCard:
      return handleCreateCard(context, state);
    case ActionType.CreateCardCustomizationReceived:
      return handleCreateCardCustomizationReceived(context, state, action);
    case ActionType.CreateCardCustomizationRejected:
      return handleCreateCardCustomizationRejected(context, state, action);
    case ActionType.CreateCardReceived:
      return handleCreateCardReceived(context, state, action);
    case ActionType.CreateCardRejected:
      return handleCreateCardRejected(context, state, action);
    case ActionType.DeactivateAccountReceived:
      return handleDeactivateAccountReceived(state);
    case ActionType.DeactivateAccountRejected:
      return handleDeactivateAccountRejected(context, state, action);
    case ActionType.ListCardsReceived:
      return handleListCardsReceived(state, action);
    case ActionType.ListCardsRejected:
      return handleListCardsRejected(context, state, action);
    case ActionType.MultipassStatusReceived:
      return handleMultipassStatusReceived(state, action);
    case ActionType.MultipassStatusRejected:
      return handleMultipassStatusRejected(context, state, action);
    case ActionType.PhoneNumberChange:
      return handlePhoneNumberChange(state, action);
    case ActionType.ProvideFeedbackReceived:
      return handleProvideFeedbackReceived(context, state, action);
    case ActionType.ProvideFeedbackRejected:
      return handleProvideFeedbackRejected(context, state, action);
    case ActionType.ShippingAddressChange:
      {
        const address = action.address;
        return [{
          ...state,
          updatedShippingAddress: address
        }, null];
      }
    case ActionType.UserChooseAccountClosureFlow:
      return handleUserChooseAccountClosureFlow(state);
    case ActionType.UserChooseDeactivateOwnCardsFlow:
      return handleUserChooseDeactivateOwnCardsFlow(state);
    case ActionType.UserClickCancellationReason:
      return handleUserClickCancellationReason(context, state, action);
    case ActionType.UserClickDeactivateAccount:
      return handleUserClickDeactivateAccount(context, state);
    case ActionType.UserClickDeactivateOwnCards:
      return handleUserClickDeactivateOwnCards(context, state);
    case ActionType.UserClickDesignNewCard:
      return handleUserClickDesignNewCard(state);
    case ActionType.UserClickConfirmCardCustomization:
      return handleUserClickConfirmCardCustomization(context, state);
    case ActionType.UserClickEditShippingAddress:
      return handleUserClickEditShippingAddress(context, state);
    case ActionType.UserClickOrderReplacementUsingSameDesign:
      return handleUserClickOrderReplacementUsingSameDesign(context, state);
    case ActionType.UserClickSendFeedback:
      return handleUserClickSendFeedback(context, state, action);
    case ActionType.UserClickSendIdvVerificationLink:
      return handleUserClickSendVerificationLink(context, state);
    case ActionType.UserClickStartChallenge:
      return handleUserClickStartChallenge(context, state);
    case ActionType.DeactivateOwnCardsReceived:
      return handleDeactivateOwnCardsReceived(context, state, action);
    case ActionType.DeactivateOwnCardsRejected:
      return handleDeactivateOwnCardsRejected(context, state, action);
    case ActionType.StartChallengeReceived:
      return handleStartChallengeReceived(context, state);
    case ActionType.StartChallengeRejected:
      return handleStartChallengeRejected(context, state, action);
    case addressValidationWorkflow.ActionType.ValidationCompleted:
      return handleUpdateNavigationAfterAddressVerification(context, state, action);
    case addressValidationWorkflow.ActionType.ChosenAddressChange:
    case addressValidationWorkflow.ActionType.NormalizedAddressChange:
    case addressValidationWorkflow.ActionType.ValidateAddress:
    case addressValidationWorkflow.ActionType.ValidateAddressReceived:
    case addressValidationWorkflow.ActionType.ValidateAddressRejected:
      {
        const [addressValidation, nextAction] = addressValidationWorkflow.update({
          sentry: context.sentry,
          validateAddress: context.validateAddress
        })(state.addressValidation, action);
        return [{
          ...state,
          addressValidation
        }, nextAction];
      }
    case cardCustomizationWorkflow.ActionType.SignatureTextChange:
    case cardCustomizationWorkflow.ActionType.SignatureFontChange:
    case cardCustomizationWorkflow.ActionType.NewCustomizationActiveChange:
      {
        const [cardCustomization, nextAction] = cardCustomizationWorkflow.update({
          newCustomizationActive: state.newCustomizationActive,
          signatureFont: state.signatureFont,
          signatureText: state.signatureText
        }, action);
        return [{
          ...state,
          ...cardCustomization
        }, nextAction];
      }
    case twoFactorWorkflow.ActionType.IncrementNavigation:
      {
        return handleIncrementNavigationFromTwoFactorScreen(context, state, action);
      }
    case twoFactorWorkflow.ActionType.UserChangePhoneNumber:
    case twoFactorWorkflow.ActionType.UserChangeVerificationCode:
    case twoFactorWorkflow.ActionType.UserClickEnroll:
    case twoFactorWorkflow.ActionType.UserClickVerify:
    case twoFactorWorkflow.ActionType.UserClickResendCode:
    case twoFactorWorkflow.ActionType.PhoneNumberEnrollTwoFactorReceived:
    case twoFactorWorkflow.ActionType.PhoneNumberEnrollTwoFactorError:
    case twoFactorWorkflow.ActionType.VerifyCodeEnrollTwoFactorReceived:
    case twoFactorWorkflow.ActionType.VerifyCodeEnrollTwoFactorError:
    case twoFactorWorkflow.ActionType.ToggleButtonLoading:
      {
        const [twoFactor, nextAction] = twoFactorWorkflow.update({
          getUUIDString: context.uuid,
          translate: key => context.intl.t(key),
          multipass: context.multipass
        })(state.twoFactor, action);
        return [{
          ...state,
          twoFactor
        }, nextAction];
      }
  }
};